// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__H5057","secondary":"button_secondary__1yQBY","onlyIcon":"button_onlyIcon__1fLs9","icon":"button_icon__MwFUV","small":"button_small__3FT5d"};